import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import "./assets/css/app.css";

import i18n from "./utils/i18n";

import { useColorSchemeStore } from "@/stores/color-scheme";
import { useBrandStore } from "@/stores/brand";
import ErrorLogger from "@template/services/ErrorLogger";

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(i18n);

ErrorLogger.init(app);

const colorSchemeStore = useColorSchemeStore();
document.documentElement.classList.add(colorSchemeStore.colorScheme);

const brandStore = useBrandStore();
brandStore.apply();
void brandStore.fetchBranding();

app.mount("#app");
